<template>
    <v-dialog class="loading-dialog fill-height" v-model="loading" persistent no-click-animation transition="fade-transition" fullscreen fluid>
        <v-container fluid fill-height class="d-flex justify-center align-center flex-column loading-overlay" :style="background" :class="{'bg-img': !!background}">
            <v-progress-linear v-if="loading" :active="loading" :indeterminate="loading" absolute top color="secondary" height="2" ></v-progress-linear>

            <div class="logo-wrapper mb-12">
                <logo :link="false" />
            </div>
            <div class="mx-auto my-12">
                <div style="max-width: 100px">
                    <v-progress-linear v-if="loading" :active="loading" :indeterminate="loading" color="primary" height="2" ></v-progress-linear>
                </div>
                
            </div>
        </v-container>
    </v-dialog>    
</template>
<script>
export default {
    props: ['loading', 'background', 'color', 'noSpinner'],
    components: {},
}
</script>
<style lang="scss" scoped>
    .loading-dialog{
        z-index: 100;
    }
    .loading-overlay{
        background-color: rgba(255, 255, 255, 0.97);
        &.bg-img{
            background-size: cover;
            background-position: bottom center;
            background-attachment: fixed;
            background-repeat: no-repeat;
            background-blend-mode: overlay;
        }
        z-index: 100;
    }
    .logo-wrapper{
        // height: 30vh;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        .logo{
            max-width: 200px;
            min-width: 150px;
            height: auto;
        }
    }
</style>